(function () {
  'use strict';

  var EXPECTED = 3;
  var finished = 0;
  var settled = false;
  var anyVisible = false;

  function root() {
    return document.querySelector('[data-mm-product-offers]');
  }

  function showLoading() {
    var el = root();
    if (!el) return;
    var loading = el.querySelector('.mmo-prod__loading');
    if (loading) {
      loading.hidden = false;
      loading.removeAttribute('aria-hidden');
      loading.style.display = '';
    }
  }

  function hideLoading() {
    var el = root();
    if (!el) return;
    var loading = el.querySelector('.mmo-prod__loading');
    if (loading) {
      loading.hidden = true;
      loading.setAttribute('aria-hidden', 'true');
      loading.style.display = 'none';
    }
  }

  function revealRoot() {
    var el = root();
    if (!el) return;
    el.style.removeProperty('display');
    el.classList.remove('mmo-prod--hidden');
  }

  function trySettle() {
    if (settled) return;

    if (anyVisible || (root() && root().querySelector('.mmo-card--ready'))) {
      settled = true;
      revealRoot();
      hideLoading();
      return;
    }

    if (finished < EXPECTED) return;

    settled = true;
    hideLoading();
    var el = root();
    if (el && !anyVisible && !el.querySelector('.mmo-card--ready')) {
      el.style.display = 'none';
      el.classList.add('mmo-prod--hidden');
    }
  }

  window.MMProductOffers = {
    widgetReady: function (didShow) {
      if (didShow) {
        anyVisible = true;
        revealRoot();
        hideLoading();
      }
      finished += 1;
      if (finished >= EXPECTED) {
        trySettle();
      }
    },
    markVisible: function (block) {
      if (!block) return;
      anyVisible = true;
      revealRoot();
      block.hidden = false;
      block.removeAttribute('hidden');
      block.style.setProperty('display', 'block', 'important');
      block.classList.add('mmo-card--ready');
      hideLoading();
    }
  };

  var queued = window.__mmWidgetReadyQueue;
  if (queued && queued.length) {
    for (var i = 0; i < queued.length; i++) {
      window.MMProductOffers.widgetReady(queued[i]);
    }
    window.__mmWidgetReadyQueue = [];
  }

  window.mmOfferWidgetReady = function (didShow) {
    if (window.MMProductOffers) {
      window.MMProductOffers.widgetReady(didShow);
    } else {
      window.__mmWidgetReadyQueue = window.__mmWidgetReadyQueue || [];
      window.__mmWidgetReadyQueue.push(!!didShow);
    }
  };

  function boot() {
    var el = root();
    if (!el) return;

    showLoading();

    var params = new URLSearchParams(window.location.search);
    if (params.get('mm_offer') || params.get('mm_ref')) {
      setTimeout(function () {
        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 800);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
